import React from 'react';
import { ShieldCheck, CreditCard, Clock, HeartHandshake } from 'lucide-react';

const trustItems = [
  {
    id: 'trust-verified',
    icon: ShieldCheck,
    color: 'text-secondary bg-teal-50',
    title: 'Verified Properties',
    description: 'Every apartment is personally managed and inspected by the owner — no surprises on arrival.',
  },
  {
    id: 'trust-payment',
    icon: CreditCard,
    color: 'text-primary bg-red-50',
    title: 'Secure Payments',
    description: 'Pay safely via Stripe — all major cards accepted. Your payment data is never stored on our servers.',
  },
  {
    id: 'trust-instant',
    icon: Clock,
    color: 'text-accent bg-yellow-50',
    title: 'Instant Confirmation',
    description: 'Receive your booking confirmation and check-in instructions within minutes of payment.',
  },
  {
    id: 'trust-host',
    icon: HeartHandshake,
    color: 'text-purple-600 bg-purple-50',
    title: 'Direct Host Support',
    description: 'Reach Maria, your host, directly by phone or message — available 7 days a week during your stay.',
  },
];

export default function TrustSection() {
  return (
    <section className="bg-muted/50 py-16">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-10">
          <p className="text-xs font-700 uppercase tracking-widest text-primary mb-2">Why Choose Us</p>
          <h2 className="text-hero-md font-800 text-foreground">Book with Confidence</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustItems?.map((item) => {
            const IconComp = item?.icon;
            return (
              <div key={item?.id} className="card-base p-6 text-center hover:shadow-card transition-shadow duration-200">
                <div className={`w-14 h-14 rounded-2xl ${item?.color} flex items-center justify-center mx-auto mb-4`}>
                  <IconComp size={24} />
                </div>
                <h3 className="font-700 text-base text-foreground mb-2">{item?.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{item?.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}